export const categories = {
  title: 'Catégories',
  description: 'Gérez vos catégories de produits',
  form: {
    createTitle: 'Nouvelle catégorie',
    editTitle: 'Modifier la catégorie',
    fields: {
      name: 'Nom',
      description: 'Description',
      type: 'Type',
      parent: 'Catégorie parente',
      isActive: 'Actif',
      image: 'Image'
    },
    placeholders: {
      name: 'Entrez le nom de la catégorie',
      description: 'Entrez la description de la catégorie',
      parent: 'Sélectionnez une catégorie parente',
      image: 'Sélectionnez une image'
    },
    validations: {
      required: 'Ce champ est requis',
      minLength: 'Ce champ doit contenir au moins {min} caractères',
      maxLength: 'Ce champ ne doit pas dépasser {max} caractères'
    },
    create: 'Créer',
    update: 'Mettre à jour',
    cancel: 'Annuler',
    submitting: 'Enregistrement...'
  },
  columns: {
    name: 'Nom',
    description: 'Description',
    type: 'Type',
    parent: 'Catégorie parente',
    isActive: 'Statut',
    image: 'Image',
    basicInfo: 'Informations de base',
    createdAt: 'Créé le',
    updatedAt: 'Mis à jour le',
    lastSync: 'Dernière synchronisation'
  },
  filters: {
    search: {
      label: 'Rechercher',
      placeholder: 'Rechercher une catégorie...'
    },
    type: {
      label: 'Type',
      product: 'Produit',
      service: 'Service'
    },
    status: {
      label: 'Statut',
      active: 'Actif',
      inactive: 'Inactif'
    }
  },
  actions: {
    newCategory: 'Nouvelle catégorie',
    edit: 'Modifier',
    delete: 'Supprimer',
    view: 'Voir'
  },
  confirmations: {
    delete: 'Êtes-vous sûr de vouloir supprimer cette catégorie ?',
    deleteSuccess: 'Catégorie supprimée avec succès',
    createSuccess: 'Catégorie créée avec succès',
    updateSuccess: 'Catégorie mise à jour avec succès'
  },
  errors: {
    load: 'Erreur lors du chargement des catégories',
    create: 'Erreur lors de la création de la catégorie',
    update: 'Erreur lors de la mise à jour de la catégorie',
    delete: 'Erreur lors de la suppression de la catégorie',
    cannotDeleteWithProducts: "Impossible de supprimer la catégorie car elle contient des produits",
    deleteError: "Erreur lors de la suppression de la catégorie"
  },
  pagination: {
    totalItems: 'Total des éléments',
    previous: 'Précédent',
    next: 'Suivant',
    page: 'Page',
    showing: 'Affichage de',
    to: 'à',
    of: 'sur',
    items: 'éléments'
  }
}; 